'use strict';

var basePage = require('../pages/base-page.js');
var rppDropdown	= require('../components/rpp-dropdown.js');
var sortDropdown = require('../components/sort-dropdown.js');

basePage.init = function() {
	basePage.initBasePage();
	rppDropdown.init();
	sortDropdown.init();
};

module.exports = basePage;